/**
 * Separator for the composite key built from a row's key values. The unit
 * separator is chosen because it does not occur in ordinary data, so ("a", "b|c")
 * and ("a|b", "c") stay distinct where a printable delimiter would collide.
 *
 * It is not, however, impossible in data: CSV parsing preserves it inside a
 * field. Rather than escape it — the SQL side builds the same key with
 * `chr(31)` concatenation, and an escape scheme that drifted between the two
 * would break every lookup — a value containing it is refused. See
 * `keySeparatorInValue` in the backend's stateful-table types.
 *
 * Shared so the frontend builds byte-identical keys when it checks a key
 * selection against a sampled file before anything is created.
 */
export const COMPOSITE_KEY_SEPARATOR = "\u001f";

/** Canonical dedupe key for an ordered list of key-column values. */
export function buildCompositeKey(values: readonly string[]): string {
  return values.join(COMPOSITE_KEY_SEPARATOR);
}
